import { call, put, takeLatest } from 'redux-saga/effects';

import * as reviewActions from './reviewActions.js';
import { updateReviewApiCall } from './reviewAPI.js';

function* updateReviewSaga({ payload }) {
  try {
    const { data } = yield call(updateReviewApiCall, payload);
    yield put(reviewActions.reviewUpdateStore(data));
  } catch (error) {
    yield put(reviewActions.reviewUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* reviewWatcher() {
  yield takeLatest(reviewActions.reviewUpdateRequest.type, updateReviewSaga);
}
